import { gql } from '@apollo/client';
export const GET_SIGNED_URL = gql `
  query GetSignedUrl($getSignedUrlInput: GetSignedUrl!) {
    driverBackOffice {
      getSignedUrl(getSignedUrlInput: $getSignedUrlInput) {
        signedUrl
        fileKey
      }
    }
  }
`;
